import { GamePeriodModel } from '../../game/models/game-period.model';
import { GameModel } from '../../game/models/game.model';
import { RankModel } from '../../ranking/models/rank.model';
import { TeamModel } from '../../team/models/team.model';

export class PlayerModel {

  /**
   * Constructor
   *
   * @param {string} iHash
   * @param {string} nickname
   * @param {string} fullname
   * @param {string} original_fullname
   * @param avatar
   * @param {RankModel} overall_rank
   * @param {TeamModel} team
   * @param {boolean} mimicked
   * @param {boolean} ghost
   * @param {GameModel} game
   * @param {boolean} gameHasEnded
   * @param {boolean} gameHasStarted
   * @param {GamePeriodModel[]} allGamePeriods
   * @param {number} rank
   * @param {string} game_salt
   */
  public constructor(
    public iHash: string = null,
    public nickname: string = null,
    public fullname: string = null,
    public original_fullname: string = null,
    public avatar: any = null,
    public overall_rank: RankModel = new RankModel(),
    public team: TeamModel = new TeamModel(),
    public mimicked: boolean = false,
    public ghost: boolean = false,
    public game: GameModel = null,
    public gameHasEnded: boolean = false,
    public gameHasStarted: boolean = false,
    public allGamePeriods: GamePeriodModel[] = [],
    public rank: number = null,
    public game_salt: string = null,
  ) { }
}
